import "./utils/googleTranslateFix";
import "./utils/googleTranslateFix";
import { initGoogleTranslate } from "./utils/googleTranslate";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { GoogleOAuthProvider } from "@react-oauth/google";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { getCurrentLang, isRtlLang } from "./utils/googleTranslate";
import { installContentLanguageHeader } from "./utils/contentLanguage";
import { installAuthRefresh, startBackgroundTokenRefresh } from "./utils/authRefresh";


import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";

initGoogleTranslate();
// Every API call carries the content language (X-Content-Language) for AI generation
installContentLanguageHeader();
// Expired access token: refresh it silently (and retry the call) instead of logging the user out
installAuthRefresh();
startBackgroundTokenRefresh();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const rtl = isRtlLang(getCurrentLang());

const cacheRtl = createCache({ key: "muirtl", stylisPlugins: [prefixer, rtlPlugin] });
const cacheLtr = createCache({ key: "muiltr" });

// Merge direction into your EXISTING theme, don't replace it
const theme = createTheme({
  // ...yourExistingThemeOptions,
  direction: rtl ? "rtl" : "ltr",
});

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GG_APP_ID!}>
          <Router>
            <App />
          </Router>
        </GoogleOAuthProvider>
      </Provider>
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
